import { z } from 'zod';
import { paginationQuerySchema } from '../pagination.js';
/**
 * Categories fonctionnelles d'un couple Mouvement x Motif.
 * `INCONNU` est le defaut neutre : un couple non qualifie n'influence aucun calcul.
 */
export const MOVEMENT_CATEGORIES = [
    'RECEPTION',
    'EXPEDITION',
    'COPACKING_IN',
    'COPACKING_OUT',
    'CASSE',
    'INVENTAIRE',
    'REGUL',
    'DESTRUCTION',
    'TRANSFERT',
    'NEUTRE',
    'INCONNU',
];
export const movementCategorySchema = z.enum(MOVEMENT_CATEGORIES);
export const MOVEMENT_CATEGORY_LABELS = {
    RECEPTION: 'Réception',
    EXPEDITION: 'Expedition',
    COPACKING_IN: 'Copacking - entrée compose',
    COPACKING_OUT: 'Copacking — sortie composants',
    CASSE: 'Casse',
    INVENTAIRE: 'Inventaire',
    REGUL: 'Régularisation',
    DESTRUCTION: 'Destruction',
    TRANSFERT: 'Transfert',
    NEUTRE: 'Neutre',
    INCONNU: 'A qualifier',
};
const codeMouvementSchema = z
    .string({ required_error: 'Code mouvement requis' })
    .trim()
    .min(1, 'Code mouvement requis')
    .max(20, 'Le code mouvement ne doit pas dépasser 20 caractères');
const motifSchema = z
    .string()
    .trim()
    .max(20, 'Le motif ne doit pas dépasser 20 caractères')
    .default('');
/**
 * Creation d'un couple. Les defauts sont **neutres** et ne sont pas negociables :
 * categorie INCONNU, declarable NULL, ecartAttendu false.
 */
export const createMovementTypeSchema = z.object({
    codeMouvement: codeMouvementSchema,
    motif: motifSchema,
    libelle: z.string().trim().max(255).nullable().default(null),
    categorie: movementCategorySchema.default('INCONNU'),
    declarable: z.boolean().nullable().default(null),
    ecartAttendu: z.boolean().default(false),
    commentaire: z.string().trim().max(2000).nullable().default(null),
});
export const updateMovementTypeSchema = z
    .object({
    libelle: z.string().trim().max(255).nullable().optional(),
    categorie: movementCategorySchema.optional(),
    declarable: z.boolean().nullable().optional(),
    ecartAttendu: z.boolean().optional(),
    commentaire: z.string().trim().max(2000).nullable().optional(),
    isActive: z.boolean().optional(),
})
    .refine((valeur) => Object.values(valeur).some((champ) => champ !== undefined), {
    message: 'Aucune modification fournie',
});
export const listMovementTypesQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(120).optional(),
    categorie: movementCategorySchema.optional(),
    /** Filtre « a qualifier » : ne renvoie que les couples restes en INCONNU. */
    aQualifier: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((valeur) => (typeof valeur === 'boolean' ? valeur : valeur === 'true'))
        .optional(),
});
//# sourceMappingURL=movement-type.js.map